import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
// Self-hosted (via @fontsource) rather than linked from fonts.googleapis.com — avoids an
// external network dependency on every page load, and Playwright's ScreenshotAsync (which
// waits on document.fonts.ready) no longer hangs for up to 30s when Google's font CDN is slow.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "./index.css";
import 'maplibre-gl/dist/maplibre-gl.css';
import { AuthProvider } from "react-oidc-context";
import { oidcConfig } from "./auth/oidcConfig";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { reportError } from "./services/errorReporting.ts";

console.log('[TD] main.tsx: module loaded, all imports resolved');

window.onerror = (message, source, line, col, error) => {
  console.error('[TD] window.onerror', { message, source, line, col, stack: error?.stack });
  reportError({
    errorType: 'Frontend',
    message: String(message),
    stackTrace: error?.stack,
  });
};

window.onunhandledrejection = (event: PromiseRejectionEvent) => {
  const err = event.reason;
  console.error('[TD] unhandledrejection', err);
  reportError({
    errorType: 'Frontend',
    message: err instanceof Error ? err.message : String(err),
    stackTrace: err instanceof Error ? err.stack : undefined,
  });
};

// MSAL Browser v3+ must be initialized before any token operations.
// Await initialization here so no component ever sees an uninitialized instance.
async function bootstrap() {
  // No provider bootstrap step is needed any more. MSAL v3 required initialize(),
  // handleRedirectPromise() to clear its interaction_in_progress flag, and an explicit
  // setActiveAccount() or acquireTokenSilent threw no_account_error. react-oidc-context
  // handles the redirect callback and account state internally; oidcConfig.onSigninCallback
  // strips the ?code=&state= params so a refresh cannot replay a consumed auth code.
  console.log('[TD] ReactDOM.createRoot — calling');
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  console.log('[TD] ReactDOM.createRoot — done, rendering');

  root.render(
    <React.StrictMode>
      <AuthProvider {...oidcConfig}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </React.StrictMode>
  );

  console.log('[TD] root.render() — called (React rendering is async, content appears shortly after)');
}

bootstrap().catch((err) => {
  console.error('[TD] bootstrap failed', err);
});
